import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import JobDetailAside from './JobDetailAside';
import JobDetailContent from './JobDetailContent';
import JobDetailHeader from './JobDetailHeader';
import { useParams } from 'react-router-dom';
import { getJobDetails } from 'nursd-dashboard/api/jobTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
// import { getFacilityDetails } from 'nursd-dashboard/api/facilityTable';
// import { getNurseUniqueIdDetails } from 'nursd-dashboard/api/nurseTable';

const JobDetail = () => {
  const { jobId } = useParams();
  const { authToken } = useAuth();
  const [job, setJob] = useState(undefined);
  const [loading, setLoading] = useState(true);
  // const [nurses, setNurses] = useState([]);

  const getJobDetail = async id => {
    // console.log(id);
    await getJobDetails(authToken, id)
      .then(async res => {
        setJob(res);
        setLoading(false);
        // await getFacilityDetails(
        //   authToken,
        //   res?.jobPostingTableFacilityTableId
        // ).then(async re => {
        //   if (res?.approved_manager && res?.closed_by) {
        //     await getFacilityDetails(
        //       authToken,
        //       res?.jobPostingTableFacilityTableId
        //     ).then(async r => {
        //       await getFacilityDetails(
        //         authToken,
        //         res?.jobPostingTableFacilityTableId
        //       ).then(rc => {
        //         setJob({
        //           ...res,
        //           manager: re,
        //           approved_manager: r,
        //           closed_manager: rc
        //         });
        //         setLoading(false);
        //       });
        //     });
        //   } else if (res?.approved_manager) {
        //     await getFacilityDetails(
        //       authToken,
        //       res?.jobPostingTableFacilityTableId
        //     ).then(r => {
        //       setJob({
        //         ...res,
        //         manager: re,
        //         approved_manager: r
        //       });
        //       setLoading(false);
        //     });
        //   } else {
        //     setJob({
        //       ...res,
        //       manager: re
        //     });
        //     setLoading(false);
        //   }
        // });
      })
      .catch(e => {
        console.log(e);
      });
  };

  // const getNurseDetail = async id => {
  //   if (id == null) {
  //     return [];
  //   } else {
  //     try {
  //       const nurseData = await getNurseUniqueIdDetails(authToken, id);
  //       return nurseData;
  //     } catch (error) {
  //       console.log('data save error:', error);
  //       return [];
  //     }
  //   }
  // };

  // const getNursesDetails = async data => {
  //   // console.log(data);
  //   const nursePromises = data
  //     ?.filter(id => id != null)
  //     .map(id => getNurseDetail(id));
  //   const nursesData = await Promise.all(nursePromises);
  //   return nursesData;
  // };

  // useEffect(() => {
  //   if (job?.jobAcceptedNurses.length > 0) {
  //     getNursesDetails(job?.jobAcceptedNurses)
  //       .then(nursesData => setNurses(nursesData))
  //       .catch(error => console.error(error));
  //   }
  // }, [job]);

  useEffect(() => {
    if (jobId) {
      getJobDetail(jobId);
    }
  }, [jobId]);

  return (
    <>
      {loading ? (
        <Card>
          <p className="m-2">Loading...</p>
        </Card>
      ) : (
        <>
          <JobDetailHeader job={job} />
          <Row className="g-3">
            <Col lg={7}>
              <JobDetailContent
                job={job}
                // nurses={nurses}
                getJobDetail={getJobDetail}
              />
            </Col>
            <Col lg={5}>
              <JobDetailAside job={job} getJobDetail={getJobDetail} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default JobDetail;
